import React from "react";
import classNames from "classnames";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(props: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.row}>
        <Skeleton className={styles.event} />
        <Skeleton
          className={classNames(styles.event, styles.halved, styles.right)}
        />
        <Skeleton
          className={classNames(styles.event, styles.quarter, styles.right)}
        />
      </div>
      <div className={styles.row}>
        <Skeleton className={styles.event} />
        <Skeleton
          className={classNames(styles.event, styles.halved, styles.left)}
        />
        <Skeleton
          className={classNames(styles.event, styles.halved, styles.left)}
        />
      </div>
      <div className={styles.row}>
        <Skeleton
          className={classNames(styles.event, styles.quarter, styles.left)}
        />
        <Skeleton
          className={classNames(styles.event, styles.quarter, styles.left)}
        />
      </div>
      {new Array(props.weeksNbr - 3).fill(0).map((_, index) => (
        <div key={index} className={styles.row} />
      ))}
    </div>
  );
}

export { Loader };
